import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import placementOptions from '../placementOptions';

const ARROW_TOP_OFFSET = 17;

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {'auto' | 'top' | 'right' | 'bottom' | 'left'} [placement]
 * @prop {boolean} [hideArrow]
 * @prop {{}} [arrowProps]
 * @prop {boolean} [show]
 * @prop {() => void} [scheduleUpdate]
 * @prop {boolean} [outOfBoundaries]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
/**
 * @type React.FC<Props & {[x: string]: any;}>
 */
const MotifTooltipContent = React.forwardRef(
  (
    {
      placement = 'right',
      hideArrow = false,
      children,
      arrowProps = null,
      show = false,
      scheduleUpdate: _ = null,
      outOfBoundaries: _1 = null,
      ...other
    },
    ref
  ) => {
    const classes = classNames('motif-tooltip', `motif-tooltip-${placement}`);
    const marginTop =
      arrowProps && arrowProps.style && arrowProps.style.top
        ? arrowProps.style.top - ARROW_TOP_OFFSET
        : 0;
    const shadowWrapper = {
      marginTop: placement === 'bottom' ? 0 : marginTop
    };

    return (
      <div ref={ref} className={classes} x-placement={placement} {...other} data-motif-tooltip-content>
        <div className="motif-tooltip-wrapper" style={shadowWrapper}>
          {!hideArrow && <div className="motif-tooltip-arrow" {...arrowProps} />}
          <div className="motif-tooltip-inner">{children}</div>
        </div>
      </div>
    );
  }
);

MotifTooltipContent.propTypes = {
  placement: PropTypes.oneOf(placementOptions),
  arrowProps: PropTypes.shape({
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
    style: PropTypes.object
  }),
  show: PropTypes.bool,
  children: PropTypes.node,
  scheduleUpdate: PropTypes.func,
  outOfBoundaries: PropTypes.bool,
  hideArrow: PropTypes.bool
};

export default MotifTooltipContent;
